const memoryStore: Record<string, string> = {}

// Mobile browser detection
function isMobileBrowser(): boolean {
  if (typeof window === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function getItem(key: string): string | null {
  try {
    if (typeof localStorage !== 'undefined') {
      const value = localStorage.getItem(key)
      // For mobile browsers, add additional validation
      if (isMobileBrowser() && value) {
        // Check if the value is still valid (not corrupted)
        try {
          if (key === 'ds_user') {
            JSON.parse(value) // Validate JSON structure
          }
        } catch {
          // Remove corrupted data
          localStorage.removeItem(key)
          return null
        }
      }
      return value
    }
  } catch (error) {
    console.warn('localStorage getItem failed:', error)
  }
  return memoryStore[key] ?? null
}

export function setItem(key: string, value: string): void {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(key, value)
      
      // For mobile browsers, add additional persistence measures
      if (isMobileBrowser()) {
        // Trigger a small storage event to ensure persistence
        window.dispatchEvent(new StorageEvent('storage', {
          key,
          newValue: value,
          storageArea: localStorage
        }))
      }
      return
    }
  } catch (error) {
    console.warn('localStorage setItem failed:', error)
  }
  memoryStore[key] = value
}

export function removeItem(key: string): void {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(key)
      
      // For mobile browsers, ensure removal is complete
      if (isMobileBrowser()) {
        // Trigger storage event to ensure removal
        window.dispatchEvent(new StorageEvent('storage', {
          key,
          newValue: null,
          storageArea: localStorage
        }))
      }
      return
    }
  } catch (error) {
    console.warn('localStorage removeItem failed:', error)
  }
  delete memoryStore[key]
}

// Clear all auth-related storage
export function clearAuthStorage(): void {
  removeItem('ds_token')
  removeItem('ds_user')
}


